import { render, staticRenderFns } from "./ReductTime.vue?vue&type=template&id=c5c118a4"
import script from "./ReductTime.vue?vue&type=script&lang=js"
export * from "./ReductTime.vue?vue&type=script&lang=js"
import style0 from "./ReductTime.vue?vue&type=style&index=0&id=c5c118a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports